import { NgModule, inject } from "@angular/core";
import { CanActivateFn, RouterModule, Routes } from "@angular/router";
import { PasswordChangeComponent } from "./password-change/password-change.component";
import { AppService } from "./app.service";
import { MainComponent } from "./main/main.component";
import { Role } from "./common/enums";

const canActivate: CanActivateFn = () => {
  return inject(AppService).isLoggedInCheck();
}

const canActivateField: CanActivateFn = () => {
  return inject(AppService).canActivate([Role.Admin, Role.Field]);
}

const canActivateCloud: CanActivateFn = () => {
  return inject(AppService).canActivate([Role.Admin, Role.Cloud]);
}

const routes: Routes = [  
  { path: '', component: MainComponent },
  { path: 'password-change', component: PasswordChangeComponent, canActivate: [canActivate] },
  { path: 'field', loadChildren: () => import('./field/field.module').then(m => m.FieldModule), canMatch: [canActivateField] },
  { path: 'RRC', loadChildren: () => import('./cloud/cloud.module').then(m => m.CloudModule), canMatch: [canActivateCloud] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }